import { ISVGIconProps } from '@northladder/design-system';

/**
 * -----------------------------------------------------------------------------
 * Renders a Bluetooth SVG icon with customizable height, width, and className.
 * The icon uses `currentColor` for its stroke, allowing color inheritance from parent elements.
 */
export function BluetoothSVGIcon({
  height = 24,
  width = 24,
  className,
}: ISVGIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="Group_2">
          <path
            d="M20 20.136L4 6.31799"
            id="Path"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M13.579 10.455L17 7.5L11 3V8.227"
            id="Path_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M16.352 16.986L11 21V12.682L6 17"
            id="Path_3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}
